import type { Client, OrganizationEventViewOptions } from "../../../../rest";

export const organizationsEventsViews = (client: Client) => ({
  record: async (organizationSlug: string, eventSlug: string) =>
    client.post(
      "/organizations/@:organizationSlug/events/:eventSlug/views",
      null,
      {
        organizationSlug,
        eventSlug,
      }
    ),
  getStreamUrl: (options: OrganizationEventViewOptions) =>
    client.url("/organizations/events/views/stream", options),
});
